import React, { useCallback } from 'react';
import { faChevronRight, faPlay } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { MegaMenu } from 'components/mega-menu/megaMenu';
import { useAppDispatch, useAppSelector } from 'ducks/hooks';
import { setModal } from 'ducks/modals/slices';
import { selectProject } from 'ducks/project/selectors';
import { selectProjects } from 'ducks/projects/selectors';
import { getScheduledBatch } from 'ducks/scheduled-batch/operators';
import { selectScheduledBatch } from 'ducks/scheduled-batch/selectors';
import { updateSettings } from 'ducks/settings/slices';
import { Link, useParams } from 'react-router-dom';
import { handleError } from 'utils/errors';

import cn from 'components/breadcrumbs/Breadcrumbs.module.scss';

interface ParamsProps {
  project_id?: number;
}

export const ScheduledBatch = () => {
  const dispatch = useAppDispatch();
  const { project_id }: ParamsProps = useParams();

  const project = useAppSelector(selectProject);
  const projects = useAppSelector(selectProjects);
  const scheduled_batch = useAppSelector(selectScheduledBatch);

  const runScheduledBatch = async () => {
    const { modified, scheduled_batch_id } = scheduled_batch;
    try {
      if (modified) {
        return;
      }

      if (scheduled_batch_id) {
        await dispatch(getScheduledBatch(scheduled_batch_id));
      }
      dispatch(setModal({ run_schedule_batch: true }));
    } catch (err) {
      handleError(err);
    }
    dispatch(updateSettings({ loading: false }));
  };

  const getJobsRoute = useCallback(() => {
    return `/projects/${project_id}/scheduled_batches/all`;
  }, [project_id]);

  const { modified, scheduled_batch_name } = scheduled_batch;
  const project_name = `${project.project_name ?? 'Projects'}`;
  return (
    <div className={cn.items}>
      <MegaMenu labels={project_name} values={projects} page="scheduled_batch" />
      <FontAwesomeIcon className={cn.breadcrumbIcon} icon={faChevronRight} />
      <Link className={cn.item} to={getJobsRoute()}>
        Scheduled Batches
      </Link>
      <FontAwesomeIcon className={cn.breadcrumbIcon} icon={faChevronRight} />
      <p className={cn.item}>{scheduled_batch_name || 'Scheduled Batch Name'}</p>
      <div className={cn.flexGrow} />
      {!modified && (
        <div className={classNames(cn.action, cn.actionPlay)} onClick={runScheduledBatch}>
          <FontAwesomeIcon icon={faPlay} color="#5cb85c" />
          <span className={cn.actionText}>Run</span>
        </div>
      )}
    </div>
  );
};
